export const navigationLinks = [
  { label: '首页', href: '#hero' },
  { label: 'APP下载', href: '#app' },
  { label: '热门榜单', href: '#ranking' },
  { label: '话题广场', href: '#topics' },
  { label: '精彩视频', href: '#media' },
  { label: '联系我们', href: '#contact' },
  { label: '最新动态', href: '#updates' },
];

export const heroData = {
  tagline: '每日更新 · 完全免费 · 下拉畅读',
  h1: '43423漫画网 — 免费漫画在线阅读首选平台',
  slogan: '韩漫、日漫、国漫，你想看的这里都有',
  intro: '43423漫画网汇聚海量免费漫画资源，涵盖韩漫、日漫、国漫等热门品类，支持下拉式阅读，无需翻页即可畅享连续阅读体验。每日更新热门连载，从校园恋爱到热血格斗，从奇幻冒险到悬疑推理，总有一部漫画让你停不下来。',
  stats: [
    { value: '30,000+', label: '漫画资源' },
    { value: '每日更新', label: '更新频率' },
    { value: '永久免费', label: '阅读承诺' },
  ],
  ctaPrimary: { label: '开始阅读', href: '#ranking' },
  ctaSecondary: { label: '下载APP', href: '#app' },
};

export const appData = {
  title: '随时随地，下拉畅读',
  description: '43423漫画网APP已覆盖iOS与Android平台，支持离线下载、书签同步和夜间模式。下拉式阅读体验，让漫画阅读更流畅、更沉浸。',
  features: ['下拉式流畅阅读', '离线下载随时看', '智能推荐不书荒', '夜间模式护眼', '书签云端同步'],
};

export const aboutData = {
  title: '关于43423漫画网',
  paragraphs: [
    '43423漫画网成立于2019年，致力于为广大漫画爱好者打造一个免费、纯净、高品质的漫画阅读平台。我们聚合了来自韩国、日本和国内的优质漫画资源，涵盖恋爱、热血、奇幻、悬疑、搞笑、都市等十余个题材分类。',
    '平台采用创新的下拉式阅读模式，告别传统翻页的繁琐操作，让阅读体验更加流畅自然。无论是通勤路上还是睡前放松，打开43423漫画网，心仪漫画瞬间呈现。',
    '我们的编辑团队每日精选优质漫画，确保内容更新及时、分类清晰、推荐精准。在这里，你不仅能追更热门连载，还能发现许多宝藏小众作品。',
  ],
};

export const rankingData = [
  { rank: 1, title: '暗夜帝王', author: '金城焕', genre: '韩漫·都市', views: '1280万', isNew: true, isHot: true, image: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20illustration%20with%20vibrant%20warm%20colors%20orange%20red%20amber%20tones%2C%20anime%20style%20character%20art%2C%20clean%20simple%20background%2C%20minimal%20design%2C%20soft%20lighting&width=112&height=144&seq=rank-cover-1&orientation=portrait' },
  { rank: 2, title: '剑道至尊', author: '陈晓光', genre: '国漫·玄幻', views: '1156万', isNew: false, isHot: true, image: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20illustration%20with%20vibrant%20warm%20colors%20orange%20red%20amber%20tones%2C%20anime%20style%20character%20art%2C%20clean%20simple%20background%2C%20minimal%20design%2C%20soft%20lighting&width=112&height=144&seq=rank-cover-2&orientation=portrait' },
  { rank: 3, title: '恋爱信号', author: '山田花子', genre: '日漫·校园', views: '987万', isNew: true, isHot: true, image: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20illustration%20with%20vibrant%20warm%20colors%20orange%20red%20amber%20tones%2C%20anime%20style%20character%20art%2C%20clean%20simple%20background%2C%20minimal%20design%2C%20soft%20lighting&width=112&height=144&seq=rank-cover-3&orientation=portrait' },
  { rank: 4, title: '末日求生录', author: '李在勋', genre: '韩漫·科幻', views: '892万', isNew: false, isHot: false, image: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20illustration%20with%20vibrant%20warm%20colors%20orange%20red%20amber%20tones%2C%20anime%20style%20character%20art%2C%20clean%20simple%20background%2C%20minimal%20design%2C%20soft%20lighting&width=112&height=144&seq=rank-cover-4&orientation=portrait' },
  { rank: 5, title: '狐妖小红娘', author: '小新', genre: '国漫·奇幻', views: '856万', isNew: false, isHot: false, image: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20illustration%20with%20vibrant%20warm%20colors%20orange%20red%20amber%20tones%2C%20anime%20style%20character%20art%2C%20clean%20simple%20background%2C%20minimal%20design%2C%20soft%20lighting&width=112&height=144&seq=rank-cover-5&orientation=portrait' },
  { rank: 6, title: '进击的异世界', author: '佐藤健太', genre: '日漫·冒险', views: '723万', isNew: true, isHot: false, image: 'https://readdy.ai/api/search-image?query=Manga%20comic%20book%20cover%20illustration%20with%20vibrant%20warm%20colors%20orange%20red%20amber%20tones%2C%20anime%20style%20character%20art%2C%20clean%20simple%20background%2C%20minimal%20design%2C%20soft%20lighting&width=112&height=144&seq=rank-cover-6&orientation=portrait' },
];

export const updatesData = [
  { date: '2026.07.28', title: '《暗夜帝王》第128话更新', desc: '主角身份揭晓，剧情迎来重大转折，千万读者在线追更。', tag: '热门' },
  { date: '2026.07.27', title: '《剑道至尊》第95话更新', desc: '终极对决一触即发，剑道大会决赛篇火热连载中。', tag: '推荐' },
  { date: '2026.07.26', title: '新作《恋爱信号》上线首日破百万', desc: '日漫校园恋爱新作强势来袭，甜度爆表引发追更狂潮。', tag: '新作' },
  { date: '2026.07.25', title: '43423夏日阅读季活动开启', desc: '参与阅读打卡赢限定周边，连续阅读7天抽大奖。', tag: '活动' },
  { date: '2026.07.24', title: '《末日求生录》第三季定档', desc: '最受期待的韩漫科幻大作第三季将于8月15日正式回归。', tag: '定档' },
  { date: '2026.07.23', title: '国漫专区内容扩充完成', desc: '新增200+部优质国漫，涵盖玄幻、武侠、都市等多题材。', tag: '更新' },
  { date: '2026.07.22', title: '阅读体验全面升级', desc: '新增智能预加载和自动书签功能，下拉阅读更丝滑。', tag: '功能' },
];

export const mediaData = [
  {
    title: '《暗夜帝王》动画化决定PV',
    desc: '人气韩漫改编动画即将上线，首支预告片震撼公开。',
    date: '2026.07.20',
    views: '256万',
  },
  {
    title: '43423漫画网三分钟漫游指南',
    desc: '从注册到追更，手把手教你玩转43423漫画网全部功能。',
    date: '2026.07.15',
    views: '189万',
  },
  {
    title: '主编推荐：2026暑期必追十部漫画',
    desc: '编辑部精选暑期档最值得追的十部热门连载，收藏不亏。',
    date: '2026.07.10',
    views: '312万',
  },
];

export const featuresData = [
  {
    icon: 'ri-download-2-line',
    title: '完全免费',
    desc: '所有漫画资源永久免费开放，无需付费订阅，放心畅读。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '创新下拉阅读模式，告别翻页，连续滑动一气呵成。',
  },
  {
    icon: 'ri-global-line',
    title: '海量资源',
    desc: '韩漫、日漫、国漫全覆盖，30000+部漫画资源持续扩充。',
  },
  {
    icon: 'ri-fire-line',
    title: '每日更新',
    desc: '编辑团队每日精选热门连载，追更不等待，更新先知道。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告、无恶意跳转，纯净阅读环境，专注漫画体验。',
  },
];

export const carouselData = [
  { tag: '韩漫热榜', title: '暗夜帝王：黑暗中的王座', desc: '地下世界的权力游戏，一个普通少年如何在黑暗中崛起，成为掌控一切的存在。金城焕代表作，连载突破120话。', genre: '都市·悬疑' },
  { tag: '新作首发', title: '恋爱信号：心跳加速的夏天', desc: '转学生与校草的偶然邂逅，一个夏天的心跳回忆。山田花子最新校园恋爱力作，甜度100%。', genre: '校园·恋爱' },
  { tag: '国漫推荐', title: '剑道至尊：万剑归宗之路', desc: '少年持剑闯天下，从废材到剑道至尊的逆袭之路。陈晓光倾力打造，国漫玄幻题材扛鼎之作。', genre: '玄幻·热血' },
  { tag: '日漫经典', title: '进击的异世界：命运之门', desc: '高中生穿越异世界，与伙伴们展开惊心动魄的冒险之旅。佐藤健太经典异世界题材，销量突破500万册。', genre: '冒险·奇幻' },
  { tag: '韩漫新番', title: '末日求生录：最后的希望', desc: '末日降临，幸存者之间的生存博弈。李在勋科幻力作，第三季即将回归，全球读者翘首以待。', genre: '科幻·生存' },
  { tag: '国漫精选', title: '狐妖小红娘：千年之约', desc: '跨越千年的爱恋，人与妖之间的羁绊故事。小新倾情创作，国漫奇幻题材人气王。', genre: '奇幻·爱情' },
];

export const indexData = [
  { title: '韩漫专区', desc: '热门韩漫连载', count: '8,500+部', icon: 'ri-kakao-talk-fill' },
  { title: '日漫专区', desc: '经典日漫合集', count: '12,000+部', icon: 'ri-earth-fill' },
  { title: '国漫专区', desc: '国产优质漫画', count: '6,800+部', icon: 'ri-china-railway-fill' },
  { title: '恋爱漫画', desc: '甜蜜恋爱故事', count: '3,200+部', icon: 'ri-heart-2-fill' },
  { title: '热血格斗', desc: '燃爆战斗场面', count: '4,500+部', icon: 'ri-flashlight-fill' },
  { title: '悬疑推理', desc: '烧脑推理佳作', count: '2,100+部', icon: 'ri-search-eye-line' },
  { title: '奇幻冒险', desc: '异世界大冒险', count: '5,600+部', icon: 'ri-compass-3-fill' },
  { title: '搞笑日常', desc: '轻松解压必备', count: '2,900+部', icon: 'ri-emotion-laugh-fill' },
  { title: '完结佳作', desc: '一口气看完', count: '9,400+部', icon: 'ri-check-double-fill' },
];

export const contactData = {
  title: '联系我们 / 投稿合作',
  description: '如果你有原创漫画作品希望入驻43423漫画网，或者对平台有任何建议和反馈，欢迎通过以下方式联系我们。我们的编辑团队将在3个工作日内回复。',
  infoItems: [
    { icon: 'ri-mail-line', label: '商务合作', value: 'cooperation@43423.com' },
    { icon: 'ri-mail-send-line', label: '作品投稿', value: 'submit@43423.com' },
    { icon: 'ri-customer-service-2-line', label: '读者反馈', value: 'feedback@43423.com' },
  ],
};

export const commentsData = [
  {
    name: '漫画迷小王',
    avatar: '王',
    date: '2026.07.25',
    comment: '用了快两年了，43423漫画网真的是我用过最舒服的免费漫画平台。下拉式阅读体验太赞了，而且没有烦人的弹窗广告，强烈推荐给所有漫画爱好者！',
    rating: 5,
  },
  {
    name: '樱花飘落',
    avatar: '樱',
    date: '2026.07.23',
    comment: '日漫资源真的很全，很多冷门作品在这里都能找到。更新速度也很快，编辑推荐的质量很高，帮我发现了好多宝藏漫画。',
    rating: 5,
  },
  {
    name: '剑气长存',
    avatar: '剑',
    date: '2026.07.20',
    comment: '作为国漫爱好者，这里的国漫专区做得太好了。玄幻和武侠分类特别细致，追更体验流畅，书签功能也很实用。',
    rating: 4,
  },
  {
    name: '熬夜冠军',
    avatar: '夜',
    date: '2026.07.18',
    comment: '每天晚上躺床上用下拉模式看漫画真的太爽了，完全不用点翻页。离线下载功能也很实用，地铁上没信号也能看。',
    rating: 5,
  },
];

export const cardsData = [
  { title: '新手必读：下拉模式使用技巧', desc: '掌握这些手势操作，让你的漫画阅读体验更加丝滑流畅。', tag: '使用指南', date: '2026.07.25' },
  { title: '编辑推荐：2026年不容错过的十部韩漫', desc: '从暗黑都市到甜蜜恋爱，这份韩漫清单帮你告别书荒。', tag: '编辑推荐', date: '2026.07.22' },
  { title: '国漫崛起：近年最值得关注的国产漫画', desc: '从画风到剧情，国产漫画正在创造属于自己的黄金时代。', tag: '行业观察', date: '2026.07.19' },
  { title: '日漫经典回顾：那些年我们追过的神作', desc: '重温那些让我们熬夜追更的经典日漫，每一部都是青春。', tag: '经典回顾', date: '2026.07.16' },
  { title: '漫画新手入门指南：如何找到适合你的作品', desc: '从题材、画风到阅读节奏，帮你找到最对胃口的漫画。', tag: '入门指南', date: '2026.07.13' },
  { title: '暑期档追更计划：七月最热连载名单', desc: '暑假来了，这份连载追更清单请收好，更新日历一目了然。', tag: '追更计划', date: '2026.07.10' },
  { title: '漫画改编影视作品大盘点', desc: '从《暗夜帝王》到《剑道至尊》，这些漫画改编影视值得期待。', tag: '影视联动', date: '2026.07.07' },
];

export const topicsData = [
  { label: '暗夜帝王', heat: '🔥1280万' },
  { label: '剑道至尊', heat: '🔥1156万' },
  { label: '恋爱信号', heat: '🔥987万' },
  { label: '下拉式阅读', heat: '892万' },
  { label: '免费漫画推荐', heat: '756万' },
  { label: '韩漫完结', heat: '689万' },
  { label: '国漫新番', heat: '621万' },
  { label: '日漫经典', heat: '543万' },
  { label: '暑期追更', heat: '498万' },
];

export const faqData = [
  {
    q: '43423漫画网真的完全免费吗？',
    a: '是的，43423漫画网所有漫画资源均为免费提供，无需付费订阅或购买VIP。我们通过平台广告维持运营，确保读者可以永久免费畅读所有漫画。',
  },
  {
    q: '什么是下拉式阅读模式？',
    a: '下拉式阅读是43423漫画网独创的阅读方式，告别传统翻页模式。您只需向下滑动屏幕，漫画内容会自动连续加载，阅读体验如同刷信息流般流畅自然，不受页面切换打断。',
  },
  {
    q: '如何找到我想看的漫画？',
    a: '您可以通过首页的搜索功能直接搜索漫画名称，或浏览首页各分类专区（韩漫、日漫、国漫等）。热门榜单和编辑推荐区域也会帮您发现优质漫画。',
  },
  {
    q: '支持离线下载阅读吗？',
    a: '43423漫画网APP支持离线下载功能。您可以在WiFi环境下预先下载想看的漫画章节，之后在无网络环境下也能正常阅读。下载的漫画会保存在本地，随时可读。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '热门连载漫画通常保持每周1-2话的更新频率。我们的编辑团队会第一时间同步最新的漫画资源，首页"最新动态"区域会实时展示更新信息，确保您不会错过任何更新。',
  },
  {
    q: '如何投稿原创漫画作品？',
    a: '欢迎原创漫画作者投稿！请将作品样章和作者简介发送至 submit@43423.com，我们的编辑团队会在3个工作日内进行审核并回复。通过审核的作品将获得首页推荐位和流量扶持。',
  },
];

export const footerData = {
  about: '43423漫画网 — 国内领先的免费漫画阅读平台，提供韩漫、日漫、国漫等海量免费漫画资源。支持下拉式阅读，每日更新，致力于为漫画爱好者打造极致的阅读体验。',
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '热门榜单', href: '#ranking' },
        { label: '最新动态', href: '#updates' },
        { label: '话题广场', href: '#topics' },
        { label: '精彩视频', href: '#media' },
      ],
    },
    {
      title: '漫画分类',
      links: [
        { label: '韩漫专区', href: '#index' },
        { label: '日漫专区', href: '#index' },
        { label: '国漫专区', href: '#index' },
        { label: '完结佳作', href: '#index' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '常见问题', href: '#faq' },
        { label: 'APP下载', href: '#app' },
      ],
    },
  ],
};